export const RESET = 'pulp/featureFlags/RESET';

export const initialState = {
  emailPropertyDataUpdate: true,
  useDataUpdateApi: false,
  enableUndisclosedPriceInCMAReport: false,
  enableUndisclosedPriceInSOIReport: false,
  enableUndisclosedPriceInUI: false,
  showNotesToVendorsOnSoi: false,
  hideOwnerNamesForVic: false,
  rapidSearchEnabled: false,
  shareReportMvp: false,
  shareableLink: false,
  nzRentalCma: false,
  nzTitleReportEnabled: false,
  propertyPriceStatement: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case RESET:
      return {...state, ...action.payload};
    default:
      return state;
  }
}

let waitingPromises = [];

export function resetFeatureFlags(payload) {
  return (dispatch) => {
    dispatch({
      type: RESET,
      payload: payload,
    });

    if (waitingPromises && Object.keys(payload).length) {
      waitingPromises.forEach(fn => fn(payload));
      waitingPromises = null;
    }
  };
}

export function awaitFeatureFlagReset() {
  return waitingPromises ?
    new Promise(resolve => waitingPromises.push(resolve)) :
    Promise.resolve();
}

export function __test_only__resetWaitingPromises() {
  waitingPromises = [];
}
